<template>
  <div class="badge-constructor-main">
    <div class="badge-title">
      <v-btn depressed @click="goBack">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      Конструктор бейджа
    </div>
    <div class="settings-subtitle">Параметры отображения бейджа</div>
    <div class="d-flex align-center badge-item-block input-active">
      <div class="switch-block">
        <v-switch
          class="switcher-left"
          v-model="badgeStatuses.eventName.status"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Название мероприятия</span>
      </div>
      <v-text-field
        class="text-field"
        label="Название мероприятия"
        v-model="badgeStatuses.eventName.name"
        required
        :disabled="!badgeStatuses.eventName.status"
        type="text"
        outlined
        :rules="[(v) => !!v || 'Обязательно к заполнению']"
      ></v-text-field>
    </div>
    <!-- <div class="d-flex align-center badge-item-block">
      <v-text-field class="text-field" label="Описание" v-model="badgeStatuses.eventDesc.desc" required type="text" :disabled="!badgeStatuses.eventDesc.status"
        outlined :rules="[(v) => !!v || 'Обязательно к заполнению']"></v-text-field>
      <v-switch class="switcher" v-model="badgeStatuses.eventDesc.status" hide-details
        color="var(--app-green-1)"></v-switch>
    </div> -->
    <div class="d-flex align-start badge-item-block">
      <div class="badge-switch-label">
        <v-switch
          class="switcher-right"
          v-model="badgeStatuses.roleState"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Роль участника</span>
      </div>
    </div>
    <div class="d-flex align-start badge-item-block">
      <div class="badge-switch-label">
        <v-switch
          class="switcher-right"
          v-model="badgeStatuses.initialsState"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">ФИО участника</span>
      </div>
    </div>
    <div class="d-flex align-start badge-item-block">
      <div class="badge-switch-label">
        <v-switch
          class="switcher-right"
          v-model="badgeStatuses.photoState"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Фото участника</span>
      </div>
    </div>
    <div class="files-container">
      <div class="container-block-title">Шаблон бейджа</div>
      <div class="container-block-subtitle">
        Пожалуйста, добавьте шаблон бейджа мероприятия в формате .html. Вы можете загрузить его как отдельный файл или в архиве.
      </div>

      <div
        class="d-flex justify-space-between"
        v-for="item in files"
        :key="item.id"
      >
        <div class="container-block-file-preview">
          <v-icon> mdi-file-pdf-box </v-icon>
          <a
            v-if="typeof item.file == 'string'"
            style="margin-left: 16px"
            target="_blank"
            :href="item.file"
            >{{ item.name }}</a
          >
          <a v-else style="margin-left: 16px" target="_blank">{{
            item.name
          }}</a>
          <v-icon
            color="var(--app-red-1)"
            style="margin-left: 24px"
            @click="doDelete"
          >
            mdi-delete-outline
          </v-icon>
        </div>
      </div>
      {{selectedFile?.name}}
      <div v-if="files.length < 1" class="container-block-gallery-button">
        <span @click="addFile">{{ selectedFile? 'Изменить файл':'Добавить файл'}}</span>
        <div style="width: 47%">
          <v-file-input
            v-show="false"
            ref="inputFile"
            outlined
            v-model="selectedFile"
            label="Прикрепите файл pdf"
            :rules="[
              (value) =>
                (value && value.size < 104857600) || 'Весом до 100 мб.',
            ]"
          ></v-file-input>
        </div>
      </div>
    </div>
    <div class="buttons-save">
      <v-btn
        style="width: auto !important"
        color="var(--app-dark-blue-1)"
        class="button-accept button-create-settings"
        @click="saveChanges"
      >
        Сохранить
      </v-btn>
      <!-- <v-btn outlined style="width: auto !important" color="var(--app-dark-blue-1)"
        class="button-create-settings button-accept-outlined" @click="goBack">
        Отмена
      </v-btn> -->
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    badgeStatuses: {
      id: "",
      eventName: {
        name: "",
        status: false,
      },
      eventDesc: {
        desc: "",
        status: false,
      },
      roleState: false,
      initialsState: false,
      photoState: false,
    },
    files: [],
    selectedFile: null,
    deleteFile: false,
  }),

  methods: {
    getSettings() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/events/badges/settings/event/${this.$route.params.id}`,
          {
            headers: {
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.badgeStatuses.id = res.data.id;
          this.badgeStatuses.eventName.name = res.data.name;
          this.badgeStatuses.eventName.status = res.data.showName;
          this.badgeStatuses.eventDesc.desc = res.data.description;
          this.badgeStatuses.eventDesc.status = res.data.showDescription;
          this.badgeStatuses.roleState = res.data.showRole;
          this.badgeStatuses.initialsState = res.data.showNSP;
          this.badgeStatuses.photoState = res.data.showPhoto;
          if (res.data.template) {
            //TODO: replace with response parameter
            let fileName = res.data.template.split("/");
            fileName = fileName.pop().split("?").shift();
            this.files.push({ name: fileName, file: res.data.template });
          }
        })
        .catch((err) => {
          if (!(err.response && err.response.status == 422)) {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          }
        });
    },
    saveChanges() {
      const form = new FormData();
      form.append("name", this.badgeStatuses.eventName.name);
      form.append("showName", this.badgeStatuses.eventName.status);
      form.append("showRole", this.badgeStatuses.roleState);
      // form.append('description', this.badgeStatuses.eventDesc.desc)
      // form.append('showDescription', this.badgeStatuses.eventDesc.status)
      form.append("showNSP", this.badgeStatuses.initialsState);
      form.append("showPhoto", this.badgeStatuses.photoState);
      form.append(
        "template",
        this.selectedFile
          ? this.selectedFile
            : null
      );
      if (this.deleteFile) {
        this.$axios
          .delete(
            this.$store.getters.apiAdminPanelV5 +
              `/events/badges/settings/pdf/${this.badgeStatuses.id}`,
            {
              headers: {
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then((res) => {
            this.deleteFile = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }

      if (!this.badgeStatuses.id) {
        form.append("eventId", this.$route.params.id);
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV5 + "/events/badges/settings",
            form,
            {
              headers: {
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then((res) => {
            //console.log('ok')
            history.go(0);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$axios
          .patch(
            this.$store.getters.apiAdminPanelV5 +
              `/events/badges/settings/${this.badgeStatuses.id}`,
            form,
            {
              headers: {
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then((res) => {
            //console.log('ok')
            history.go(0);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    goBack() {
      this.$router.push({
        name: "DetailEvent",
        params: { id: this.$route.params.id },
      });
    },
    addFile() {
      this.$refs.inputFile.$el.querySelector("input").click();
    },
    doDelete() {
      this.files = [];
      this.deleteFile = true;
    },
  },
  watch: {
    selectedFile(newVal) {
      if (
        newVal &&
        newVal.type == "application/pdf"
      ) {
        this.files.push({ name: newVal.name, file: newVal });
        this.deleteFile = false;
      }
    },
  },
  mounted() {
    this.getSettings();
  },
};
</script>

<style lang="scss" scoped>
.badge-constructor-main {
  width: 100%;
  .badge-title {
    font-size: 24px;
    font-weight: 500;
    line-height: 30.58px;
    margin: 40px 0px 0px 32px;

    display: flex;
    align-items: center;
    gap: 16px;

    button {
      width: 88px;
      height: 44px;
    }
  }
  .settings-subtitle {
    margin: 40px 0px 32px 32px;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .badge-item-block {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row nowrap;
    width: 52%;
    margin: 24px 0px 24px 32px;

    .text-field {
      height: 56px;
    }
    .switch-label {
      width: 130px;
    }
    .switcher {
      margin-left: 24px;
    }
    .switcher-right {
      margin-right: 24px;
    }
    .badge-switch-label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
    }
  }

  .input-active {
    display: flex;
    flex-flow: row wrap;
    gap: 24px;
    .switch-block {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 24px;

      span {
        width: 100%;
      }
    }
  }
  .files-container {
    width: 50%;
    margin-bottom: 20px;
    margin: 40px 0px 40px 32px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 9px;
    }

    .container-block-subtitle {
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
    }
  }

  .buttons-save,
  .buttons-create {
    display: flex;
    flex-flow: column wrap;
    max-width: 112px;
    gap: 12px;
    margin: 20px 0px 0px 32px;
    .button-create-settings {
      color: white;
      cursor: pointer;
    }
  }
}
</style>
